import React from "react";
import {AApp} from "@cisco-sbg-ui/magna-react";
import {Provider} from "react-redux";
import useShellPositioning from "hooks/useShellPositioning";
import store from "./store";
import "./AppWrapper.module.scss";

export default function AppWrapper({children, theme}) {
  const {header} = useShellPositioning();

  return (
    <AApp
      persistTheme
      theme={theme}
      style={{minHeight: `calc(100vh - ${header.height}px)`}}>
      <Provider store={store}>{children}</Provider>
    </AApp>
  );
}
